import { inject, Injectable } from '@angular/core';
import { EdifactConfigService } from './edifact-config.service';
import { EdifactSegmentSuffix } from '../models/edifact-segment-suffix';
import { EdifactCharacterSet } from '../models/edifact-character-set';
import { EdifactSyntax } from '../models/edifact-syntax';
import { X12ConfigService } from './x12-config.service';
import { X12AuthorizationQualifier } from '../models/x12-authorization-qualifier';
import { X12CharacterSet } from '../models/x12-character-set';
import { X12SecurityQualifier } from '../models/x12-security-qualifier';

export class EdiConfigContainer {
  constructor(
    public ediSegmentSuffixes: EdifactSegmentSuffix[],
    public edifactCharacterSets: EdifactCharacterSet[],
    public edifactSyntaxes: EdifactSyntax[],
    public authorizationQualifiers: X12AuthorizationQualifier[],
    public characterSets: X12CharacterSet[],
    public securityQualifiers: X12SecurityQualifier[],
  ) { }
}

/**
 * Helper service which can load all needed configurations for Edifact and X12
 */
@Injectable({
  providedIn: 'root'
})
export class EdiConfigHelperService {
  private x12ConfigService = inject(X12ConfigService);
  private edifactConfigService = inject(EdifactConfigService);

  public async loadConfigurations(): Promise<EdiConfigContainer> {
    const [
      ediSegmentSuffixes,
      edifactCharacterSets,
      edifactSyntaxes,
      authorizationQualifiers,
      characterSets,
      securityQualifiers
    ] = await Promise.all([
      this.edifactConfigService.getEdifactSegmentSuffixes(),  // Find segment-suffixes
      this.edifactConfigService.getCharacterSets(),           // Find character-sets
      this.edifactConfigService.getSyntaxes(),                // Find syntaxes
      this.x12ConfigService.getAuthorizationQualifiers(),     // Find authorizationqualifiers
      this.x12ConfigService.getCharacterSets(),               // Find character-sets
      this.x12ConfigService.getSecurityQualifiers()           // Find security-qualifiers
    ]);

    return new EdiConfigContainer(ediSegmentSuffixes, edifactCharacterSets, edifactSyntaxes, authorizationQualifiers, characterSets, securityQualifiers);
  }
}
